export default __webpack_public_path__ + "static/media/img4.e05233dd.PNG";